module.exports = __webpack_public_path__ + "static/img/格里森直齿锥齿轮的计算.844ae816.jpg";